import { createFileRoute } from '@tanstack/react-router'
import { ResourcesPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/resources/')({
  loader: () => loadPageData({ data: { kind: 'resources', locale: 'en' } }),
  head: () => staticRouteHead('resources', 'en'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <ResourcesPage />
    </CatalogProvider>
  )
}
